export const wpToKwpConverter = (wp: number | string): string => {
  const kwp = Number(wp) / 1000;

  return kwp.toFixed(3);
};
